var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-collapse-item',{staticClass:"dashboard-right-item",attrs:{"name":_vm.accordeonTabName}},[_c('template',{staticClass:"item-title-block",slot:"title"},[_vm._t("title")],2),_c('div',{staticClass:"item-content-block"},[_vm._t("content")],2)],2)
}
var staticRenderFns = []

export { render, staticRenderFns }